export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center bg-background-50 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none" style={{
        backgroundImage: 'url(https://readdy.ai/api/search-image?query=Abstract%20minimalist%20product%20collage%20with%20soft%20overlapping%20geometric%20shapes%20in%20warm%20cream%20and%20terracotta%20tones%2C%20artistic%20texture%20with%20subtle%20fabric%20and%20material%20patterns%2C%20clean%20editorial%20composition%2C%20very%20low%20contrast%20watermark%20style%20with%20gentle%20curves&width=1600&height=900&seq=hero-bg-texture-v3&orientation=landscape)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }} />

      <div className="absolute inset-0 bg-gradient-to-b from-background-50/60 via-transparent to-background-50/60" />

      <div className="relative z-10 w-full px-6 md:px-10 lg:px-20 pt-24 pb-20">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          <div className="flex-1 max-w-2xl">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-accent-300 bg-accent-100/60 mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-500" />
              <span className="text-xs font-semibold text-accent-800 uppercase tracking-wide">Updated Daily</span>
            </div>

            <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-extrabold text-foreground-950 leading-[1.05] tracking-tight">
              VigorBuy<br />
              Spreadsheet<br />
              <span className="text-primary-500">2026</span>
            </h1>

            <p className="mt-6 text-base md:text-lg text-foreground-600 leading-relaxed max-w-lg">
              The Ultimate Buying Resource for Sneakers, Clothing &amp; More
            </p>

            <p className="mt-4 text-sm md:text-base text-foreground-500 leading-relaxed max-w-lg">
              Access the latest VigorBuy spreadsheet, verified product links, QC guides, shipping tutorials, and buying resources trusted by thousands of shoppers worldwide.
            </p>

            <div className="flex flex-wrap items-center gap-3 mt-8">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                Explore Spreadsheet
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-sm" />
                </span>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold border-2 border-foreground-800 text-foreground-800 rounded-full hover:bg-foreground-800 hover:text-background-50 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                Start Buying
              </a>
              <a
                href="/article/vigorbuy-spreadsheet-guide"
                className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
              >
                View Latest Updates
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-sm" />
                </span>
              </a>
            </div>

            <div className="flex flex-wrap items-center gap-4 md:gap-6 mt-10">
              {[
                'Updated Daily',
                'QC Verified Products',
                'Shipping Guides',
                'Secure Resources',
              ].map((badge) => (
                <div key={badge} className="flex items-center gap-1.5 text-xs text-foreground-500">
                  <span className="w-3.5 h-3.5 flex items-center justify-center text-accent-500">
                    <i className="ri-check-line text-xs" />
                  </span>
                  {badge}
                </div>
              ))}
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg">
            <div className="relative rounded-2xl overflow-hidden border border-background-200/60 bg-background-50">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20premium%20sneakers%20and%20streetwear%20clothing%20items%20artfully%20arranged%20on%20warm%20cream%20surface%2C%20soft%20natural%20afternoon%20light%20from%20the%20right%20creating%20gentle%20elongated%20shadows%2C%20clean%20editorial%20aesthetic%2C%20neutral%20warm%20earth%20tone%20palette%2C%20professional%20fashion%20catalog%20style%20with%20varied%20textures&width=700&height=600&seq=hero-product-showcase-v3&orientation=portrait"
                alt="VigorBuy Spreadsheet Product Showcase - Sneakers and Clothing"
                title="VigorBuy Spreadsheet Product Collection"
                className="w-full h-auto object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>

        <div className="mt-20 md:mt-28 text-center">
          <p className="font-heading text-2xl md:text-4xl lg:text-5xl font-extrabold text-foreground-950/10 tracking-tighter leading-none select-none">
            BUY SMARTER. BUY FASTER.
          </p>
        </div>
      </div>
    </section>
  );
}